/*
  CLOSET: カートクーポン（snippets/cart-coupon.liquid の動き）
  - ミニカートはセクションごと描き直されるので、document でイベントを受ける
  - 適用・取り消しは /cart/update.js の discount。ミニカートは cart:refresh、カートページは再読み込み
  - 計測: Shopify.analytics.publish（カスタムイベント）と gtag があれば両方
*/
(() => {
  if (window.__cartCouponReady) return;
  window.__cartCouponReady = true;

  const track = (name, params = {}) => {
    try { window.Shopify?.analytics?.publish?.(name, params); } catch (e) {}
    try { window.gtag?.('event', name, params); } catch (e) {}
  };

  const root = (el) => el.closest('[data-cart-coupon]');

  // カートページのモーダル（右から出るクーポン一覧）
  // ページ表示時に body 直下へ移して画面外で待機させる（押した瞬間に移動・描画させるとスライドの出だしが飛ぶ）
  const drawerOf = () => document.querySelector('.cart-coupon__panel--drawer:not([data-stale])');
  const prepareDrawer = () => {
    const panel = drawerOf();
    if (!panel || panel.dataset.ready) return panel;
    panel.setAttribute('data-cart-coupon', '');
    panel.dataset.context = 'page';
    panel.dataset.ready = '1';
    panel.setAttribute('aria-hidden', 'true');
    document.body.appendChild(panel);
    panel.hidden = false;
    return panel;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareDrawer); else prepareDrawer();
  const openDrawer = () => {
    const panel = prepareDrawer();
    if (!panel) return false;
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-open');
    document.documentElement.classList.add('cart-coupon-locked');
    tick();
    track('cart_coupon_open', { context: 'page' });
    setTimeout(() => panel.querySelector('.cart-coupon__close')?.focus({ preventScroll: true }), 460);
    return true;
  };
  const closeDrawer = () => {
    const panel = drawerOf();
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-coupon-locked');
  };
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  const setMessage = (box, text) => {
    const m = box.querySelector('[data-cart-coupon-message]');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
  };

  // カートページのセクションID（Section Rendering API で、クーポン適用と同じリクエストでカートの HTML を受け取る）
  const pageSectionId = () => {
    const el = document.getElementById('cart-recap-form')?.closest('.shopify-section');
    return el ? el.id.replace('shopify-section-', '') : null;
  };

  const refresh = (box, cart) => {
    if (box.dataset.context === 'page') {
      const id = pageSectionId();
      const html = cart?.sections?.[id];
      const wrap = id && document.getElementById(`shopify-section-${id}`);
      if (!html || !wrap) { window.location.reload(); return; }
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(`shopify-section-${id}`);
      if (!fresh) { window.location.reload(); return; }
      // 古いモーダル（body 直下に移したもの）は閉じるアニメーションが終わってから片付ける。中身はすぐ差し替える
      document.querySelectorAll('body > .cart-coupon__panel--drawer').forEach((p) => { p.dataset.stale = '1'; setTimeout(() => p.remove(), 500); });
      wrap.replaceChildren(...fresh.childNodes);
      prepareDrawer();
      syncSticky();
      return;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  };

  const applyCode = async (box, code) => {
    const buttons = box.querySelectorAll('button');
    buttons.forEach((b) => (b.disabled = true));
    const applyBtn = box.querySelector('[data-cart-coupon-apply]');
    const applyLabel = applyBtn?.textContent;
    if (applyBtn) applyBtn.textContent = code ? '適用中…' : '処理中…';
    setMessage(box, '');
    const sectionId = box.dataset.context === 'page' ? pageSectionId() : null;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(sectionId ? { discount: code, sections: sectionId, sections_url: window.location.pathname } : { discount: code })
      });
      const cart = await res.json();
      if (code) {
        const hit = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code.toUpperCase());
        if (!hit || !hit.applicable) {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '' })
          });
          setMessage(box, 'このクーポンは今のカートでは使えません。条件（金額・対象商品・期限）をご確認ください。');
          track('cart_coupon_invalid', { code });
          buttons.forEach((b) => (b.disabled = false));
          if (applyBtn) applyBtn.textContent = applyLabel;
          return;
        }
        track('cart_coupon_apply', { code, context: box.dataset.context });
      } else {
        track('cart_coupon_remove', { context: box.dataset.context });
      }
      if (box.dataset.context === 'page') closeDrawer();
      refresh(box, cart);
    } catch (e) {
      setMessage(box, '通信に失敗しました。時間をおいてもう一度お試しください。');
      buttons.forEach((b) => (b.disabled = false));
      if (applyBtn) applyBtn.textContent = applyLabel;
    }
  };

  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    const now = Date.now() / 1000;
    document.querySelectorAll('[data-cart-coupon] [data-ends]').forEach((card) => {
      const el = card.querySelector('[data-countdown]');
      if (!el) return;
      let s = Math.max(0, Math.floor(Number(card.dataset.ends) - now));
      const d = Math.floor(s / 86400); s -= d * 86400;
      const h = Math.floor(s / 3600); s -= h * 3600;
      const m = Math.floor(s / 60); s -= m * 60;
      el.textContent = `あと${d > 0 ? `${d}日` : ''}${pad(h)}:${pad(m)}:${pad(s)}`;
    });
  };
  setInterval(tick, 1000);

  // カートページ（スマホ）: 画面下の固定バーに、購入ボタン上の帯を複製する。
  // ページ内の購入ボタンが画面に見えている間は、固定バーを隠して二重に見えないようにする
  const syncSticky = () => {
    const sticky = document.querySelector('[data-cart-sticky]');
    const slot = document.querySelector('[data-cart-sticky-coupon]');
    if (!sticky || !slot) return;
    const src = document.querySelector('.cart__recap .cart-coupon-bar');
    if (src) slot.replaceChildren(src.cloneNode(true)); else slot.hidden = true;
    document.body.classList.add('has-cart-sticky');
    const target = document.querySelector('.cart__checkout-button');
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-hidden', e.isIntersecting), { threshold: 0.1 }).observe(target);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncSticky); else syncSticky();

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-coupon-close]') || event.target.classList?.contains('cart-coupon__panel--drawer')) { closeDrawer(); return; }

    const toggle = event.target.closest('[data-cart-coupon-toggle]');
    if (toggle && root(toggle)?.dataset.context === 'page' && drawerOf()) { openDrawer(); return; }
    if (toggle) {
      const box = root(toggle);
      const panel = box.querySelector('[data-cart-coupon-panel]');
      const open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) { tick(); track('cart_coupon_open', { context: box.dataset.context }); }
      return;
    }

    const jump = event.target.closest('[data-cart-coupon-jump]');
    if (jump) { if (!openDrawer()) document.querySelector('.cart-coupon--page')?.scrollIntoView({ behavior: 'smooth' }); return; }

    const apply = event.target.closest('[data-cart-coupon-apply]');
    if (apply) {
      const box = root(apply);
      const checked = box.querySelector('.cart-coupon__radio:checked');
      if (!checked) { setMessage(box, 'クーポンを選んでください。'); return; }
      const appliedCard = box.querySelector('.cart-coupon__card--applied');
      if (appliedCard && appliedCard.dataset.code === checked.value) { setMessage(box, 'このクーポンは適用済みです。'); return; }
      applyCode(box, checked.value);
      return;
    }

    const remove = event.target.closest('[data-cart-coupon-remove]');
    if (remove) { applyCode(root(remove), ''); return; }

    const unlock = event.target.closest('[data-unlock]');
    if (unlock) {
      const card = unlock.closest('[data-code]');
      track('cart_coupon_unlock_click', { code: card?.dataset.code, context: root(unlock)?.dataset.context });
    }
  });

  // ===== カートページ: ショッパー・アップセル（2026-10-17） =====
  // どちらも Section Rendering API でカートを描き直す（ページの再読み込みなし）
  const PAGE = { dataset: { context: 'page' } };
  const cartPost = async (path, body) => {
    const id = pageSectionId();
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(id ? { ...body, sections: id, sections_url: window.location.pathname } : body)
    });
    if (!res.ok) throw new Error(String(res.status));
    const json = await res.json();
    refresh(PAGE, json);
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return json;
  };

  // ショッパー: チェックした時点でカートに入れる（以前はアプリが購入手続きを押した瞬間に足していて、カートで金額が見えなかった）
  document.addEventListener('change', async (event) => {
    const check = event.target.closest?.('.cart-shopper__check');
    if (!check) return;
    const label = check.closest('[data-cart-shopper]');
    label.classList.add('is-busy');
    check.disabled = true;
    try {
      await cartPost('cart/update.js', { updates: { [label.dataset.variantId]: 1 }, attributes: { Option: 'CLOSET Original Shopping Bag' } });
      track('cart_shopper_add', {});
    } catch (e) {
      check.checked = false; check.disabled = false; label.classList.remove('is-busy');
    }
  });

  // アップセルの「+ 追加」: カートページではその場で追加して描き直す
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('.cart-upsell--page .cart-upsell__form');
    if (!form || !pageSectionId()) return;
    event.preventDefault();
    const btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.textContent = '追加中…'; }
    try {
      await cartPost('cart/add.js', { items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] });
      track('cart_upsell_add', { context: 'page' });
    } catch (e) {
      form.submit();
    }
  });

  // カートページでは、アプリのショッパー欄（購入手続きの瞬間に足す方式）は使わない。隠したうえで、チェックが残っていたら外す
  const disableAppShopper = () => {
    document.querySelectorAll('#dw-embed-widget-mounts .option-widgets input:checked').forEach((i) => i.click());
  };
  // ショッパーを商品一覧から削除したあとに残る注文属性（Option）を消す
  const clearStaleShopperAttr = () => {
    if (!document.querySelector('[data-cart-shopper-stale]')) return;
    fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { Option: '' } }) });
  };
  const onCartPageReady = () => { if (!pageSectionId()) return; clearStaleShopperAttr(); setTimeout(disableAppShopper, 2500); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onCartPageReady); else onCartPageReady();
  document.addEventListener('submit', (event) => { if (event.target.id === 'cart-recap-form') disableAppShopper(); }, true);

  // テーマ側（数量変更・削除）がカートを描き直したとき、新しいクーポン一覧を body 直下に移し直す
  new MutationObserver((records) => {
    const fresh = records.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && n.parentElement !== document.body && (n.matches?.('.cart-coupon__panel--drawer') || n.querySelector?.('.cart-coupon__panel--drawer'))));
    if (!fresh) return;
    document.querySelectorAll('body > .cart-coupon__panel--drawer:not([data-stale])').forEach((p) => { if (p.classList.contains('is-open')) return; p.dataset.stale = '1'; setTimeout(() => p.remove(), 500); });
    prepareDrawer();
    syncSticky();
    clearStaleShopperAttr();
  }).observe(document.documentElement, { childList: true, subtree: true });

  // カートページ（スマホ）ヘッダーの戻るボタン: 直前がこのストアのページならそこへ戻り、外から来たとき（LINE のリンクなど）はトップへ
  document.addEventListener('click', (event) => {
    const back = event.target.closest('[data-header-back]');
    if (!back) return;
    let sameStore = false;
    try { sameStore = !!document.referrer && /(^|\.)closet-by-haji\.(com|myshopify\.com)$/.test(new URL(document.referrer).host) && history.length > 1; } catch (e) {}
    if (sameStore) history.back(); else window.location.href = back.dataset.fallback || '/';
  });

  const manual = (box) => {
    const input = box.querySelector('[data-cart-coupon-input]');
    const code = (input?.value || '').trim();
    if (code) applyCode(box, code);
  };
  document.addEventListener('click', (event) => {
    const reg = event.target.closest('[data-cart-coupon-register]');
    if (reg) manual(root(reg));
  });
  // 手入力欄で Enter を押しても、購入用フォームを送信しない
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest?.('[data-cart-coupon-input]');
    if (!input) return;
    event.preventDefault();
    manual(root(input));
  });
})();
